const LAY_DANH_SACH_CHUC_VU_THANH_CONG = (state, danhSachNhomChucVu) => {
  state.nhomChucVu = danhSachNhomChucVu;
};

const TAO_CHUC_VU_THANH_CONG = (state, nhomChucVu) => {
  state.nhomChucVu.push(
    Object.assign({}, nhomChucVu, { ID: state.nhomChucVuId })
  );
};

const CAP_NHAT_CHUC_VU_THANH_CONG = (state, nhomChucVu) => {
  const editItemIndex = state.nhomChucVu.findIndex(
    (obj) => obj.ID === nhomChucVu.ID
  );
  state.nhomChucVu[editItemIndex] = nhomChucVu;
};

const XOA_CHUC_VU_THANH_CONG = (state, nhomChucVu) => {
  let objIndex = state.nhomChucVu.findIndex(
    (item) => item.ID === nhomChucVu.ID
  );
  state.nhomChucVu.splice(objIndex, 1);
};

const LAY_CHI_TIET_CHUC_VU_THANH_CONG = (state, nhomChucVuId) => {
  state.nhomChucVuId = nhomChucVuId;
};

export default {
  LAY_DANH_SACH_CHUC_VU_THANH_CONG,
  TAO_CHUC_VU_THANH_CONG,
  CAP_NHAT_CHUC_VU_THANH_CONG,
  XOA_CHUC_VU_THANH_CONG,
  LAY_CHI_TIET_CHUC_VU_THANH_CONG,
};
